import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useModalQueryParam from 'hooks/useModalQueryParam';
import ShareContentModal from 'screens/ShareModal';
import Icon from 'components/Icon';
import MultipleSelectionHeader from 'components/MultipleSelectionHeader';
import FixedHeightTab from 'components/Tab/FixedHeightTab';
import { NavMenuItem } from 'components/NavMenu';
import { StickyEditorPageHeaderWrapper } from 'components/EditorPageHeader';
export function ShareMultiContentOption(_ref) {
  var shareData = _ref.shareData,
    includesDeleted = _ref.includesDeleted;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useModalQueryParam = useModalQueryParam('share'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasShareModal = _useModalQueryParam2[0],
    toggleShareModal = _useModalQueryParam2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavMenuItem, {
    onClick: function onClick() {
      return toggleShareModal();
    },
    isDisabled: includesDeleted
  }, t('actions_share_all')), hasShareModal && /*#__PURE__*/React.createElement(ShareContentModal, {
    data: shareData,
    onClose: toggleShareModal
  }));
}
function MultiAssetHeader(_ref2) {
  var titleId = _ref2.titleId,
    assets = _ref2.assets,
    shareData = _ref2.shareData,
    tabLinks = _ref2.tabLinks,
    onClose = _ref2.onClose;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var selectedCount = assets.length;
  var includesDeleted = assets.some(function (asset) {
    return asset.isDeleted;
  });
  var title = t('asset_selection_status_plural', {
    count: selectedCount
  });
  return /*#__PURE__*/React.createElement(StickyEditorPageHeaderWrapper, null, /*#__PURE__*/React.createElement(MultipleSelectionHeader, {
    cardVariant: "raised",
    title: title,
    titleId: titleId,
    selection: assets,
    onClose: onClose,
    menuItems: shareData && /*#__PURE__*/React.createElement(ShareMultiContentOption, {
      shareData: shareData,
      includesDeleted: includesDeleted
    })
  }, /*#__PURE__*/React.createElement(FixedHeightTab, {
    isActive: tabLinks.details.isActive,
    as: Link,
    to: tabLinks.details.link,
    "aria-current": tabLinks.details.isActive ? 'page' : undefined
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "asset-image",
    mr: "xs"
  }), t('panel_tab_details'))));
}
export default MultiAssetHeader;